import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { TermsAndConditionsContainer, TermsAndConditionsText, TermsAndConditionsTextSlider, ChevronWrapper } from './styled';
import { ChevronLink } from '@chegg-ui/link';
import { TOGGLE_TESTID, SUB_TEXT_TESTID, TNC_SLIDER_TESTID } from './constants';
var TermsAndConditions = function TermsAndConditions(_ref) {
  var tncPromptText = _ref.tncPromptText,
    termsAndConditions = _ref.termsAndConditions,
    isOpen = _ref.isOpen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggle = _useState2[0],
    setToggle = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var handleToggle = function handleToggle() {
    setToggle(!toggle);
    setActive(!active);
  };
  return /*#__PURE__*/React.createElement(TermsAndConditionsContainer, null, /*#__PURE__*/React.createElement(ChevronWrapper, {
    "data-test": TOGGLE_TESTID,
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(ChevronLink, {
    style: {
      cursor: 'pointer'
    },
    "data-test": SUB_TEXT_TESTID,
    size: 'medium',
    chevronDirection: toggle ? 'up' : 'down'
  }, termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.contentTitle)), active ? /*#__PURE__*/React.createElement(TermsAndConditionsTextSlider, {
    "data-test": TNC_SLIDER_TESTID
  }, /*#__PURE__*/React.createElement(TermsAndConditionsText, {
    isOpen: isOpen
  }, tncPromptText)) : null);
};
export default TermsAndConditions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/TermsAndConditions/index.js
// module id = 4714
// module chunks = 11